import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTogglComponent } from './simple-icons-toggl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTogglComponent ],
    exports:      [ SimpleIconsTogglComponent ],
    bootstrap:    []
})
export class SimpleIconsTogglModule {}
